import React from 'react';
import { Box, Button, Theme, Typography } from '@mui/material';
import ArrowForward from '@mui/icons-material/ArrowForward';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginTop: theme.spacing(3),
    maxWidth: '80%',
    wordBreak: 'break-word',
  },
  messageText: {
    color: 'var(--text-primary-dark)',
    fontSize: 'var(--label-medium-accent-font-size)',
    fontWeight: 'var(--label-medium-accent-font-weight)',
    lineHeight: 'var(--label-medium-accent-line-height)',
    marginBottom: 'var(--buyer-copilot-message-block-gap)',
  },
  actionButton: {
    borderColor: 'var(--buyer-copilot-enabled)',
    color: 'var(--buyer-copilot-enabled)',
    fontSize: 'var(--label-medium-accent-font-size)',
    fontWeight: 'var(--label-large-accent-font-weight)',
    lineHeight: 'var(--label-medium-accent-line-height)',
    '&:hover': {
      borderColor: 'var(--buyer-copilot-enabled)',
      backgroundColor: 'var(--subscription-highlight-background-color)',
    },
  },
}));

interface PostToGroupChatMessageProps {
  message?: string;
  buttonLabel?: string;
  onPostToGroupChat: () => void;
  isConversationEnabled: boolean;
}

const DEFAULT_MESSAGE =
  "I couldn't find an answer to your question. Do you want to post it on the group chat?";
const DEFAULT_MESSAGE_WITH_CONVERSATION_DISABLED =
  "I couldn't find an answer to your question.";
const DEFAULT_BUTTON_LABEL = 'Post on Group Chat';

const PostToGroupChatMessage: React.FC<PostToGroupChatMessageProps> = (
  props: PostToGroupChatMessageProps
): JSX.Element => {
  const classes = useStyles();
  const {
    message,
    buttonLabel = DEFAULT_BUTTON_LABEL,
    onPostToGroupChat,
    isConversationEnabled,
  } = props;

  const finalMessage =
    message ||
    (isConversationEnabled
      ? DEFAULT_MESSAGE
      : DEFAULT_MESSAGE_WITH_CONVERSATION_DISABLED);

  return (
    <Box className={classes.container}>
      <Typography className={classes.messageText}>{finalMessage}</Typography>
      {isConversationEnabled && (
        <Button
          variant="outlined"
          className={classes.actionButton}
          onClick={onPostToGroupChat}
          endIcon={<ArrowForward />}
          sx={{ textTransform: 'none' }}
        >
          {buttonLabel}
        </Button>
      )}
    </Box>
  );
};

export default PostToGroupChatMessage;
